// @flow
import React from "react";

import BasicButton from "../BasicButton";
import Typography from "../Typography";

import styles from "./searchFormTabs.module.scss";

type T = (string, string) => string;

type Props = {
  active: "hourly" | "monthly",
  onChange: (value: "hourly" | "monthly") => void,
  reverse?: boolean,
  t: T
};

const cypress = "search-form-tabs";

const SearchFormTabs = ({ active, onChange, reverse, t }: Props) => {
  const isHourly = active === "hourly";
  const reverseClass = reverse ? styles.reverse : "";

  return (
    <div className={`${styles.base} ${reverseClass}`} data-cy={cypress}>
      <BasicButton
        onClick={() => {
          onChange("hourly");
        }}
        cypress={`${cypress}${isHourly ? "-active" : ""}`}
      >
        <Typography bold={isHourly} color={isHourly ? "brand" : "primary"}>
          <div className={isHourly ? styles.activeTab : styles.tab}>
            {t("searchForm:hourlyDaily", "Hourly / Daily")}
          </div>
        </Typography>
      </BasicButton>
      <BasicButton
        onClick={() => {
          onChange("monthly");
        }}
        cypress={`${cypress}${!isHourly ? "-active" : ""}`}
      >
        <Typography bold={!isHourly} color={!isHourly ? "brand" : "primary"}>
          <div className={!isHourly ? styles.activeTab : styles.tab}>
            {t("searchForm:monthly", "Monthly")}
          </div>
        </Typography>
      </BasicButton>
    </div>
  );
};

export default SearchFormTabs;
